import React from 'react';
import Sidemenu from '../components/base/sidemenu';
import DashboardRedesign from '../components/dashboard/DashboardRedesign';

export default function DashboardPage() {
  return (
    <div className="flex">
      <Sidemenu />
      <DashboardRedesign />
    </div>
  );
}